import { RootState } from "../store.types"

export const selectAccount = (state: RootState) => state.savings.data
